module.exports = __webpack_public_path__ + "img/Close - Gray.9f18d2cd.png";